import { get } from 'lodash-es'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import PRODUCTS_CONSTANTS from '@/js/plugins/store/modules/products/constants.js'

import VuexPersistence from 'vuex-persist'
export const vuexPersistence = new VuexPersistence({
  key: 'dp2020',
  reducer: state => ({
    [STOREMODULES.APP]: {
      [APP_CONSTANTS.HELP_PATH]: get(state, [STOREMODULES.APP, APP_CONSTANTS.HELP_PATH]),
      [APP_CONSTANTS.RETURN_FROM_HELP]: get(state, [
        STOREMODULES.APP,
        APP_CONSTANTS.RETURN_FROM_HELP,
      ]),
      [APP_CONSTANTS.SEARCH_URL]: get(state, [STOREMODULES.APP, APP_CONSTANTS.SEARCH_URL]),
      [APP_CONSTANTS.PRODUCT_VIEW]: get(state, [STOREMODULES.APP, APP_CONSTANTS.PRODUCT_VIEW]),
      [APP_CONSTANTS.RETURN_ROUTE]: get(state, [STOREMODULES.APP, APP_CONSTANTS.RETURN_ROUTE]),
      [APP_CONSTANTS.SELECTED_BRAND]: get(state, [STOREMODULES.APP, APP_CONSTANTS.SELECTED_BRAND]),
      [APP_CONSTANTS.FILTERS]: get(state, [STOREMODULES.APP, APP_CONSTANTS.FILTERS]),
      // [APP_CONSTANTS.SEARCH_PARAMS]: get(state, [STOREMODULES.APP, APP_CONSTANTS.SEARCH_PARAMS]),
    },
    [STOREMODULES.PRODUCTS]: {
      // [PRODUCTS_CONSTANTS.CATALOGTREEPAGE_URL]: get(state, [
      //   STOREMODULES.PRODUCTS,
      //   PRODUCTS_CONSTANTS.CATALOGTREEPAGE_URL,
      // ]),
      [PRODUCTS_CONSTANTS.CATALOGTREE_PATH]: get(state, [
        STOREMODULES.PRODUCTS,
        PRODUCTS_CONSTANTS.CATALOGTREE_PATH,
      ]),
      [PRODUCTS_CONSTANTS.CATALOGTAB_ID]: get(state, [
        STOREMODULES.PRODUCTS,
        PRODUCTS_CONSTANTS.CATALOGTAB_ID,
      ]),
      [PRODUCTS_CONSTANTS.QUICKBUY_LIST]: get(state, [
        STOREMODULES.PRODUCTS,
        PRODUCTS_CONSTANTS.QUICKBUY_LIST,
      ]),
      [PRODUCTS_CONSTANTS.SNSEARCH_LIST]: get(state, [
        STOREMODULES.PRODUCTS,
        PRODUCTS_CONSTANTS.SNSEARCH_LIST,
      ]),
    },
  }),
})
